/**
 * Controller: GroupsRolesAddModal
 */
angular.module('acme.view.application.groups.roles.addModal.controllers', [
  'acme.common.service.api'
])
.controller('GroupsRolesAddModalController', [ '$scope', '$uibModalInstance', 'ApiService', 'groupData', 'groupRoles', 'HelpersService', function ($scope, $uibModalInstance, ApiService, groupData, groupRoles, HelpersService) {

    $scope.errors = [];

    $scope.model = [];

    $scope.query = '';

    $scope.init = function() {

      ApiService.roles.list(HelpersService.getPaginator()).then(function(response) {
        var i, ii,
          j, jj,
          roles = response.data.payload.list;

        for (i=0,ii=roles.length;i<ii;i++) {
          for (j=0,jj=groupRoles.length;j<jj;j++) {
            if (roles[i].id === groupRoles[j].id) {
              roles[i].selected = true;
              break;
            }
          }
        }

        $scope.model = roles;

      }, function(response) {
        // TODO: Backfill
      });
    };

    $scope.checkQuery = function(user, query) {
      var q = '';
      if (user.name) {
        q += user.name;
      }
      if (user.displayName) {
        q += user.displayName;
      }

      console.log('GroupsRolesAddModalController::search', query);
      return (q.indexOf(query) === -1);
    };

    $scope.hasErrors = function() {
      return ($scope.errors.length > 0);
    };


    $scope.getSelected = function() {
      var i, ii,
          roles = [],
          mappings = [];

      // Returns only the relationship between user and group
      for (i=0,ii=$scope.model.length;i<ii;i++) {
        if ($scope.model[i].selected) {
          roles.push($scope.model[i]);
          mappings.push({
            roleId: $scope.model[i].id,
            userGroupId: groupData.id
          });
        }
      }

      return { mappings: mappings, roles: roles };
    };

    $scope.done = function() {
      $scope.success();
    };

    $scope.cancel = function () {
      $uibModalInstance.dismiss('cancel');
    };

    $scope.success = function () {
      $uibModalInstance.close($scope.getSelected());
    };

    $scope.init();

}]);